import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { BaseResponseClass } from '../models/response/base-response-class.model';
import { PreparePixResponse } from '../models/response/PreparePix.response';
import { NotificationService } from './notification.service';
import { runtimeEnv } from 'src/environments/env-loader';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RestService {
  private headers = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(private http: HttpClient, private notification: NotificationService) {}

  private buildUrl(endpoint: string): string {
    if (endpoint.startsWith('http')) {
      return endpoint;
    }
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
    return `${runtimeEnv.APIURL}/${cleanEndpoint}`;
  }

  postLogin(endPoint: string, data: any): Observable<any> {
    return this.http.post(this.buildUrl(endPoint), data, this.headers);
  }

  getPayList(endPoint: string, data: any): Observable<any> {
    return this.http.post(this.buildUrl(endPoint), data, this.headers);
  }

  postConsulta(endPoint: string, fd: FormData): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.post(this.buildUrl(endPoint), fd).subscribe(
        (response: BaseResponseClass) => {
          if (response.resultCode == -1 || response.resultCode == -1001) {
            reject(new Error(response.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.error?.message));
        }
      );
    });
  }

  postToken(endPoint: string, data: any, token: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
      this.http.post(this.buildUrl(endPoint), data, { headers }).subscribe(
        (response: any) => {
          if (response.resultCode == -1) {
            reject(new Error(response.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.error?.message));
        }
      );
    });
  }

  post(endPoint: string, data: any): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.post(this.buildUrl(endPoint), data, this.headers).subscribe(
        (response: BaseResponseClass) => {
          if (response.resultCode == -1) {
            reject(new Error(response?.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.error?.message));
        }
      );
    });
  }

  public postLoginClover(endPoint: string, data: any): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.post(this.buildUrl(endPoint), data, this.headers).subscribe(
        (response: BaseResponseClass) => {
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.error?.message));
        }
      );
    });
  }

  postImage(endPoint: string, data: FormData): Promise<BaseResponseClass> {
    const headers = new HttpHeaders({
      Accept: 'application/json, text/plain, */*'
    });

    return new Promise((resolve, reject) => {
      this.http.post(this.buildUrl(endPoint), data, { headers }).subscribe(
        (response: BaseResponseClass) => {
          if (response.resultCode == -1) {
            reject(new Error(response?.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.error?.message));
        }
      );
    });
  }

  postGeneric(endPoint: string, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(this.buildUrl(endPoint), data, this.headers).subscribe(
        (response: any) => {
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.error?.message));
        }
      );
    });
  }

  postPix(endPoint: string, data: any): Promise<PreparePixResponse> {
    return new Promise((resolve, reject) => {
      this.http.post(this.buildUrl(endPoint), data, this.headers).subscribe(
        (response: PreparePixResponse) => {
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          if (error.status === 504) {
            this.notification.showError(
              'Recomendamos intentar nuevamente en unos minutos, disculpe las molestas ocasionadas.',
              'Exceso de tiempo en la solicitud'
            );
          } else {
            reject(error.error);
          }
        }
      );
    });
  }

  put(endPoint: string, data: any): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.put(this.buildUrl(endPoint), data, this.headers).subscribe(
        (response: BaseResponseClass) => {
          if (response.resultCode == -1 || response.resultCode == -1001) {
            reject(new Error(response.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.error?.message));
        }
      );
    });
  }

  delete(endPoint: string, data?: any): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.delete(this.buildUrl(endPoint), data).subscribe(
        (response: any) => {
          if (response.resultCode == -1 || response.resultCode == -1001) {
            reject(new Error(response.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.error?.message));
        }
      );
    });
  }

  get(endPoint: string, headers?: any): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.get(this.buildUrl(endPoint), this.headers).subscribe(
        (response: BaseResponseClass) => {
          if (response.resultCode !== 0) {
            reject(new Error(response.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error?.message));
        }
      );
    });
  }

  getPix(endPoint: string): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.get(this.buildUrl(endPoint), this.headers).subscribe(
        (response: any) => {
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(error.error);
        }
      );
    });
  }

  getPoll(endPoint: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.buildUrl(endPoint), this.headers).subscribe(
        (response: any) => {
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.message));
        }
      );
    });
  }

  getSimple(endPoint: string): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.get(this.buildUrl(endPoint), {}).subscribe(
        (response: BaseResponseClass) => {
          if (response.resultCode !== 0) {
            reject(new Error(response.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          // No se hace nada con el error
        }
      );
    });
  }

  private urlAssemblerStatus(endPoint: string): string {
    const baseUrl = runtimeEnv.APIURL.replace(/\/api$/, '');
    return `${baseUrl}/${endPoint}`;
  }

  getStatus(endPoint: string, headers?: any): Promise<BaseResponseClass> {
    return new Promise((resolve, reject) => {
      this.http.get(this.urlAssemblerStatus(endPoint), this.headers).subscribe(
        (response: BaseResponseClass) => {
          if (response.resultCode !== 0) {
            reject(new Error(response.message));
          }
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          reject(new Error(error.message));
        }
      );
    });
  }

  // Métodos con Observables y manejo de errores opcional
  post$(endPoint: string, data: any, headers?) {
    return this.http
      .post(this.buildUrl(endPoint), data, headers || this.headers)
      .pipe(catchError((error) => throwError(error)));
  }

  get$(endPoint: string, headers?: any) {
    return this.http
      .get(this.buildUrl(endPoint), headers || this.headers)
      .pipe(catchError((error) => throwError(error)));
  }
}
